import { FlexBox } from "components/Common/FlexBox"
import { DotLoading, InfiniteScroll, SpinLoading } from "antd-mobile"
import NoSuggestionMeal from "components/Icons/NoSuggestionMeal"
import { RecentIngredientType } from "model/food/types/recentIngredient.types"
import RecentIngredientItem from "./RecentIngredientItem"
import {
  RecentIngredientsWrapper,
  Title,
  RecentIngredientsContent,
  IngredientDivider,
  NoRecentIngredientDescription,
} from "./styled"
import NotFound from "features/meal/ScanMeal/NotFound"
import NotFoundIcon from "components/Icons/NotFoundIcon"
import NotFoundIconLarge from "components/Icons/NotFoundIconLarge"

const NoRecentIngredients = () => {
  return (
    <FlexBox
      $direction="column"
      $alignItems="center"
      $justify="center"
      style={{ padding: "32px 0px" }}
      $gap={16}
    >
      <NotFoundIconLarge />
      <NoRecentIngredientDescription>
        No recent ingredients added
      </NoRecentIngredientDescription>
    </FlexBox>
  )
}

const InfiniteScrollContent = ({
  isFirstLoad,
  isLoading,
  hasMore,
}: {
  isFirstLoad: boolean
  isLoading: boolean
  hasMore: boolean
}) => {
  if (isFirstLoad) {
    return (
      <FlexBox $alignItems="center" $justify="center" style={{ height: 200 }}>
        <SpinLoading />
      </FlexBox>
    )
  }

  if (hasMore) {
    return isLoading ? (
      <FlexBox
        style={{ height: 40, width: "100%" }}
        $justify="center"
        $alignItems="center"
      >
        <span>Loading more ingredients</span>
        <DotLoading />
      </FlexBox>
    ) : null
  }

  return "All ingredients found"
}

interface RecentIngredientsProps {
  ingredients: RecentIngredientType[]
  isNoRecentIngredients: boolean
  loadMore: () => Promise<any>
  loading: boolean
  hasMore: boolean
  swipedId: string | null
  setSwipedId: (id: string | null) => void
  onAdd: (ingredient: RecentIngredientType) => void
  onSelect: (ingredient: RecentIngredientType) => void
  onDelete: (id: string) => void
  contentRef?: React.RefObject<HTMLDivElement>
}

const RecentIngredients = ({
  ingredients,
  isNoRecentIngredients,
  loadMore,
  loading,
  hasMore,
  swipedId,
  setSwipedId,
  onAdd,
  onSelect,
  onDelete,
  contentRef,
}: RecentIngredientsProps) => {
  return (
    <RecentIngredientsWrapper>
      <Title>Recent</Title>
      {isNoRecentIngredients ? (
        <NoRecentIngredients />
      ) : (
        <RecentIngredientsContent ref={contentRef}>
          {ingredients.map((ingredient, index) => (
            <div key={ingredient.id}>
              <RecentIngredientItem
                ingredient={ingredient}
                swipedId={swipedId}
                setSwipedId={setSwipedId}
                onAdd={onAdd}
                onSelect={onSelect}
                onDelete={onDelete}
              />
              {index !== ingredients.length - 1 && <IngredientDivider />}
            </div>
          ))}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
            <InfiniteScrollContent
              hasMore={hasMore}
              isLoading={loading}
              isFirstLoad={!ingredients.length}
            />
          </InfiniteScroll>
        </RecentIngredientsContent>
      )}
    </RecentIngredientsWrapper>
  )
}

export default RecentIngredients
